module.exports = __webpack_public_path__ + "assets/content.3ffce679.svg";